"use strict";
// TODO lets use the library one it is stable.
// import { validate as uuidValidate } from 'uuid';
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUuid = isUuid;
/**
 * Validates if a provided id string has UUID format.
 * @param id the Id to evaluate.
 */
function isUuid(id) {
    // This regex was taken from the library
    var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
    return REGEX.test(id);
}
